import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HttpClientWrapper {
  private readonly apiURL = environment.apiURL;

  httpOptions = {
    withCredentials: true,
  };

  private httpClient = inject(HttpClient);

  get<T>(url: string, params = {}): Observable<T> {
    return this.httpClient
      .get<T>(this.apiURL + url, { ...this.httpOptions, params })
      .pipe(catchError(this.handleError<T>('get:' + url)));
  }

  delete<T>(url: string, params = {}): Observable<T> {
    return this.httpClient
      .delete<T>(this.apiURL + url, { ...this.httpOptions, params })
      .pipe(catchError(this.handleError<T>('delete:' + url)));
  }

  post<T>(url: string, body: object, params = {}): Observable<T> {
    return this.httpClient
      .post<T>(this.apiURL + url, body, { ...this.httpOptions, params })
      .pipe(catchError(this.handleError<T>('post:' + url)));
  }

  put<T>(url: string, body: object, params = {}): Observable<T> {
    return this.httpClient
      .put<T>(this.apiURL + url, body, { ...this.httpOptions, params })
      .pipe(catchError(this.handleError<T>('put:' + url)));
  }

  private handleError<T>(operation: string) {
    return (error: any): Observable<T> => {
      console.error(operation, error);
      return throwError(() => error);
    };
  }
}
